<template>
  <div v-if="isLoading" class="loading-overlay">
    <div class="loading-container">
      <div class="loading-logo">
        <h2 class="loading-title">加载中</h2>
      </div>
      
      <div class="progress-section">
        <div class="progress-bar">
          <div 
            class="progress-fill" 
            :style="{ width: progress + '%' }"
          ></div>
        </div>
        <div class="progress-text">{{ Math.round(progress) }}%</div>
        <div class="current-task">{{ currentTask }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingProgress',
  props: {
    isLoading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      progress: 0,
      currentTask: '正在加载...'
    }
  },
  methods: {
    // 更新加载进度（从外部调用）
    updateRealProgress(progressValue, task = '') {
      // 确保进度值在0-100范围内
      const clampedProgress = Math.min(Math.max(progressValue, 0), 100);
      this.progress = clampedProgress;
      
      if (task) {
        this.currentTask = task;
      }
      
      console.log(`加载进度: ${clampedProgress}% - ${task || this.currentTask}`);
      
      // 当进度达到100%时，延迟显示完成状态，然后隐藏加载界面
      if (clampedProgress >= 100) {
        console.log('达到100%，准备隐藏加载界面...');
        // 确保100%状态能够显示
        setTimeout(() => {
          console.log('发射loading-complete事件');
          this.$emit('loading-complete');
        }, 1000); // 延迟1秒让用户清楚看到100%完成状态
      }
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  font-family: 'Microsoft YaHei', sans-serif;
}

.loading-container {
  text-align: center;
  color: white;
  padding: 40px;
}

.loading-logo {
  margin-bottom: 30px;
}

.loading-title {
  font-size: 1.5rem;
  font-weight: 300;
  margin: 0;
}

.progress-section {
  margin-top: 30px;
}

.progress-bar {
  width: 200px;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
  margin: 0 auto 15px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #4facfe 0%, #00f2fe 100%);
  border-radius: 3px;
  transition: width 0.3s ease-out;
  box-shadow: 0 0 10px rgba(79, 172, 254, 0.3);
}

.progress-text {
  font-size: 1.1rem;
  margin-bottom: 10px;
}

.current-task {
  font-size: 0.9rem;
  opacity: 0.8;
}
</style>